import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT_PAGES = { websites: false, social: false, two_point_oh: true };
const SiteCtx = createContext({ pages: DEFAULT_PAGES, ready: false, setPages: () => {} });

export function SiteProvider({ children }) {
  const [pages, setPagesState] = useState(DEFAULT_PAGES);
  const [ready, setReady] = useState(false);

  const refresh = useCallback(() => api.get("/site/settings").then((r) => setPagesState(r.data.pages)).catch(() => {}).finally(() => setReady(true)), []);
  useEffect(() => { refresh(); }, [refresh]);

  return <SiteCtx.Provider value={{ pages, ready, setPages: setPagesState, refresh }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
